const getters = {
  reportHS_$allPermissions (state) {
    return (state.reportPreferences.author.hasOwnProperty('all_permissions'))
      ? state.reportPreferences.author.all_permissions
      : []
  },
}
export default getters
